/**
 * 사업장 선택 목록
 * ---------------------------------------------------------------------------
 * 이름이 같은 사업장이 둘 이상이면 코드를 붙여 구분한다.
 *
 * 이름만 보여 주었더니 같은 이름의 사업장 셋 가운데 어느 것을 골랐는지 알 수
 * 없었고, 일지가 사업장 여러 곳에 나뉘어 들어갔다. 대시보드는 첫 번째 것을
 * 골라 "차트가 비었다" 로 보였다. 이름이 겹칠 때만 코드를 붙인다 — 늘 붙이면
 * 한 곳뿐인 대부분의 기업에서 읽을 거리만 는다.
 */

import type { Site } from '@eco/shared';

export function siteOptions(sites: Site[] | undefined): Array<{ value: string; label: string }> {
  const list = sites ?? [];
  const count = new Map<string, number>();
  for (const s of list) count.set(s.siteName, (count.get(s.siteName) ?? 0) + 1);

  return list.map((s) => ({
    value: s.siteId,
    label: (count.get(s.siteName) ?? 0) > 1 ? `${s.siteName} (${s.siteCode})` : s.siteName,
  }));
}
